<template>
	<div class="cart-list__table-item grid-x" v-if="mandatory === false">
		<!-- No input -->
		<template v-if="inputType == ''">
			<div class="cart-list__table-label cell small-8">
				{{ description }}
			</div>
			<div class="cart-list__table-price cell small-12 medium-4">
				<span>{{ convertPrice(price) }} {{ currency }}</span>
			</div>
		</template>

		<!-- Checkbox or radiobutton input -->
		<template v-if="inputType == 'Checkbox' || inputType == 'Radiobutton'">
			<div class="cart-list__table-label cell small-9 medium-8">
				<svg width="14" height="7" viewBox="0 0 14 7" xmlns="http://www.w3.org/2000/svg" v-if="completeCancellation && extraspoollid === 1 && !isChecked" v-bind:svg-inline="''" v-bind:class="'highlight-icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M7 7a.998.998 0 01-.64-.232l-6-5A1.001 1.001 0 011.64.232l5.36 4.466L12.358.232a1.001 1.001 0 011.282 1.536l-6 5a.998.998 0 01-.64.232" fill-rule="evenodd"/></svg>
				<div
					:id="extraspoollid === 1 ? 'cancellation' : ''"
					class="input-wrapper"
					:class="
						completeCancellation && extraspoollid === 1 && !isChecked
							? 'highlight'
							: ''
					"
				>
					<Checkbox
						v-if="mandatory === true"
						:cartStyling="true"
						:isDisabled="true"
						:data-id="poollid"
						@check-input="
							(val, id) => {
								onClickCheckbox(val, id)
							}
						"
						:label="description"
					/>
					<Checkbox
						v-if="mandatory === false"
						:cartStyling="true"
						:isDisabled="
							allowmodify == false || allowcancellation == false ? true : false
						"
						:isChecked="convertToBool(isChecked)"
						:data-id="poollid"
						@check-input="
							(val, id) => {
								onClickCheckbox(val, id)
							}
						"
						:label="description"
					/>
					<Tooltip :title="tooltipTitle" :text="[tooltipText]" />
				</div>
				<p v-if="mandatory === true" class="italic colorPrimary7">
					({{ $t('cart.includedInPrice') }})
				</p>
			</div>
			<div class="cart-list__table-unit-price cell show-for-medium medium-2">
				<span>{{ convertPrice(price) }} {{ currency }}</span>
			</div>
			<div class="cart-list__table-price cell small-3 show-for-medium medium-2">
				<span>
					{{ convertPrice(convertToBool(isChecked) * price) }} {{ currency }}
				</span>
			</div>

			<!-- Mobile version of á price and total price -->
			<div class="cart-list__table-price cell small-3 hide-for-medium">
				<span>
					<span v-if="!isChecked" style="color: #cdcdcd;">
						{{ convertPrice(price) }} {{ currency }}
					</span>
					<span v-else>
						{{ convertPrice(convertToBool(isChecked) * price) }} {{ currency }}
					</span>
				</span>
			</div>
			<!-- <div class="highlight cell small-12"></div> -->
		</template>

		<!-- Editbox or dropdown input -->
		<template v-if="inputType == 'Editbox' || inputType == 'Dropdown'">
			<div class="cart-list__table-label cell small-12">
				<div class="input-wrapper">
					<span class="cart-list__input-label">{{ description }}</span>
					<Tooltip :title="tooltipTitle" :text="[tooltipText]" />
				</div>
				<div class="grid-x">
					<div class="cell small-9 medium-8">
						<NumberComponent
							:initalValue="quantity"
							:maxNumber="maxQty"
							:minNumber="detlid ? original_qty : minQty"
							:disablePlus="allowmodify === false"
							:disableMinus="allowmodify === false"
							:lightTheme="true"
							@number-input="
								(val, id) => {
									onClickButton(val, id)
								}
							"
						/>
					</div>
					<div
						class="cart-list__table-unit-price cart-list__table-unit-price--align-center cell show-for-medium medium-2"
					>
						<span>{{ price }} {{ currency }}</span>
					</div>
					<div
						class="cart-list__table-price cart-list__table-price--align-center cell show-for-medium medium-2"
					>
						<span>{{ bedsetTotalPrice }} {{ currency }}</span>
					</div>

					<!-- Mobile version of á price and total price -->
					<div
						class="cart-list__table-price cart-list__table-price--align-center cell small-3 hide-for-medium"
					>
						<span>
							<span v-if="bedsetTotalPrice == 0" style="color: #cdcdcd;">
								{{ price }} {{ currency }}
							</span>
							<span v-else>{{ bedsetTotalPrice }} {{ currency }}</span>
						</span>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import mixin from '../../mixin'
import store from '../../vueX/store'

import NumberComponent from '../atoms/NumberComponent.vue'
import Checkbox from '../atoms/Checkbox.vue'
import Tooltip from '../molecules/Tooltip'

export default {
	name: 'AccommodationAddon',
	mixins: [mixin],
	props: {
		description: {
			type: String,
			default: ''
		},
		price: {
			type: Number,
			default: 0
		},
		currency: {
			type: String,
			default: ''
		},
		inputType: {
			type: String,
			default: ''
		},
		mandatory: {
			type: Boolean,
			default: false
		},
		isChecked: {
			type: Number,
			default: 0
		},
		poollid: {
			type: Number,
			default: 0
		},
		objectId: {
			type: Number,
			default: 0
		},
		quantity: {
			type: Number,
			default: 0
		},
		maxQty: {
			type: Number,
			default: 0
		},
		minQty: {
			type: Number,
			default: 0
		},
		original_qty: {
			type: Number,
			default: 0
		},
		detlid: {
			type: Number
		},
		tooltipTitle: {
			type: String,
			default: ''
		},
		tooltipText: {
			type: String,
			default: ''
		},
		lastChild: {
			type: Boolean,
			default: false
		},
		allowmodify: {
			type: Boolean,
			default: false
		},
		allowcancellation: {
			type: Boolean,
			default: false
		},
		extraspoollid: {
			type: Number,
			default: 0
		}
	},
	components: {
		NumberComponent,
		Checkbox,
		Tooltip
	},
	methods: {
		onClickCheckbox(event) {
			this.$emit('clicked', event, this.poollid, this.objectId, this.detlid)
		},
		onClickButton(event) {
			this.$emit('clicked', event, this.poollid, this.objectId, this.detlid)
		}
	},
	computed: {
		bedsetTotalPrice() {
			let bedsetTotalPrice
			bedsetTotalPrice = this.price * this.quantity
			return new Intl.NumberFormat(this.$t('currency')).format(bedsetTotalPrice)
		},
		completeCancellation() {
			return store.state.cart.completeCancellation
		}
	}
}
</script>

<style scoped lang="scss">
.highlight {
	margin: -7px 0 0 -7px;
	padding: 5px;
	border: 2px solid #64c7bc;
	border-radius: 5px;
}

.highlight-icon {
	fill: #64c7bc;
	transform: rotate(-90deg);
	position: absolute;
	left: -30px;
	margin-top: 7px;
	animation: point 0.6s infinite alternate ease-in-out;
}

@keyframes point {
	0% {
		transform: translateX(0) rotate(-90deg);
		opacity: 0.4;
	}
	100% {
		transform: translateX(5px) rotate(-90deg);
		opacity: 0.9;
	}
}
</style>
